import { NavigateRoutesEnum } from '@features/routing/routesEnum';
import { AppRolesEnum } from '@features/routing/appRolesEnum';
import { MenuItem, MenuSubItem } from '@layouts/toolbar/MenuItem';



const reportingsMenuDefinition: MenuSubItem[] = [
	{
		id: NavigateRoutesEnum.reportingReducedOrders,
		name: 'Pokrácené objednávky',
		requiredRoles: AppRolesEnum.reducedOrdersReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingReducedMaterials,
		name: 'Pokrácené materiály',
		requiredRoles: AppRolesEnum.reducedMaterialsReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingRedatedOrders,
		name: 'Předatumované objednávky',
		requiredRoles: AppRolesEnum.redatedOrdersReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingUndeliveredOrders,
		name: 'Nedoručené objednávky',
		requiredRoles: AppRolesEnum.undeliveredOrdersReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingShipmentStops,
		name: 'MCHD',
		requiredRoles: AppRolesEnum.mchdReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingDeliveriesSummary,
		name: 'Dodávky - Main',
		requiredRoles: AppRolesEnum.countryDeliveriesSummaryReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingDeliveriesTradesDc,
		name: 'Dodávky - Trades Dc',
		requiredRoles: AppRolesEnum.countryDeliveriesTradesDepoReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingDeliveriesTradesDistrict,
		name: 'Dodávky - Trades District',
		requiredRoles: AppRolesEnum.countryDeliveriesTradesDistrictReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingDeliveriesCustomer,
		name: 'Dodávky - Customer',
		requiredRoles: AppRolesEnum.countryDeliveriesCustomerReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingDeliveriesSku,
		name: 'Dodávky - Sku',
		requiredRoles: AppRolesEnum.countryDeliveriesSkuReport_Read,
	},
	{
		id: NavigateRoutesEnum.reportingDeliveriesSkuDc,
		name: 'Dodávky - Sku Dc',
		requiredRoles: AppRolesEnum.countryDeliveriesSkuReportDcDetail_Read,
	},
	{
		id: NavigateRoutesEnum.reportingDeliveriesSkuDistrict,
		name: 'Dodávky - Sku District',
		requiredRoles: AppRolesEnum.countryDeliveriesSkuReportDistrictDetail_Read,
	},
]



export const menuDefinition: MenuItem[] = [
	{
		id: NavigateRoutesEnum.basePath,
		name: 'Přehled'
	},
	{
		id: NavigateRoutesEnum.customers,
		name: 'Zákazníci',
		requiredRoles: AppRolesEnum.customers_Read,
	},
	{
		id: NavigateRoutesEnum.orders,
		name: 'Objednávky',
		requiredRoles: AppRolesEnum.orders_Read,
	},
	{
		id: 'Reporty',
		name: 'Reporty',
		requiredRoles: reportingsMenuDefinition.reduce((allRequiredRoles: string[], reportingMenuItem) => {
			if (reportingMenuItem.requiredRoles) {
				const rolesArray = typeof reportingMenuItem.requiredRoles === 'string'
					? [ reportingMenuItem.requiredRoles ]
					: reportingMenuItem.requiredRoles;
				return allRequiredRoles.concat(rolesArray)
			}
			return allRequiredRoles;
		}, []),
		items: reportingsMenuDefinition
	},
];